import { Stack } from '@mantine/core';
import { GetFileFromDirectoryStep } from '@/types/automationSteps.ts';
import StepCommonFields from '@/pages/Editor/components/SharedFields/StepCommonFields.tsx';
import SingleDataInputSelector from '@/pages/Editor/components/SharedFields/DataInputSelector/SingleDataInputSelector.tsx';
import GetFileFromDirectoryFields from '@/pages/Editor/components/StepSidebar/StepForms/GetFileFromDirectoryStep/GetFileFromDirectoryFields.tsx';
import OutputNameField from '@/pages/Editor/components/SharedFields/OutputNameField.tsx';
import StepAdvancedConfigFields from '@/pages/Editor/components/SharedFields/StepAdvancedConfigFields.tsx';

type props = {
  step: GetFileFromDirectoryStep;
};

export function GetFileFromDirectoryForm({ step }: props) {
  return (
    <Stack gap="md">
      <StepCommonFields step={step} nameLabel={'Step Name'} />
      {/*<Divider />*/}
      <SingleDataInputSelector step={step} />
      {/*<Divider />*/}
      <GetFileFromDirectoryFields step={step} />
      <OutputNameField step={step} />
      <StepAdvancedConfigFields step={step} />
    </Stack>
  );
}
